import styled from '@emotion/styled';
import { alpha, Box, Tab, Tabs } from '@mui/material';
import { GridRow } from '../../styles';
import { shouldForwardProps } from '../../utils';
import { Breakpoint, getBreakpointValue } from '../../types';

const TabBarContainer = styled(Box, shouldForwardProps)`
    display: grid;
    // makes TabBar take up 100% of the parent container and does not exceed that
    grid-template-columns: repeat(auto-fit, minmax(0, 100%));
    border-radius: 12px;
    gap: ${({ theme }) => theme.spacing(3)};
`;

const CategoryTabsContainer = styled(GridRow)`
    justify-content: space-around;
    width: 100%;
`;

type CategoryTabsProps = {
    justifyStart: boolean;
    wrapTabs?: boolean;
};
const CategoryTabs = styled(Tabs, shouldForwardProps)<CategoryTabsProps>`
    flex: 1;
    width: 100%;
    border-bottom: ${({ theme }) => theme.colors.surfaceVariant} 1px solid;
    .MuiTabs-flexContainer {
        justify-content: ${({ justifyStart }) => (justifyStart ? `flex-start` : `space-around`)};
    }
    .MuiTabs-scrollButtons.Mui-disabled {
        opacity: 0.3;
    }
    ${({ wrapTabs }) =>
        wrapTabs &&
        `.MuiTabs-indicator {
        display: none;
    }
    .MuiTabs-flexContainer {
        flex-wrap: wrap;
    }`}
`;

const CategoryTab = styled(Tab, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-transform: none;
    color: ${({ theme }) => theme.colors.sysDarkOnPrimary};
    height: 32px;
    margin-left: ${({ theme, breakpoint }) =>
        theme.spacing(getBreakpointValue(breakpoint, 1, 2, 4))};
    margin-right: ${({ theme, breakpoint }) =>
        theme.spacing(getBreakpointValue(breakpoint, 1, 2, 4))};
    margin-bottom: 8px;
    margin-top: 4px;
    padding-right: ${({ theme, breakpoint }) =>
        theme.spacing(getBreakpointValue(breakpoint, 1, 2, 4))};
    padding-left: ${({ theme, breakpoint }) =>
        theme.spacing(getBreakpointValue(breakpoint, 1, 2, 4))};
    &:focus {
        border: 2px solid ${({ theme }) => theme.colors.white};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px ${({ theme }) => theme.colors.primary},
            0 0 0 4px ${({ theme }) => alpha(theme.colors.primary, 0.4)};
    }
`;

export { CategoryTabsContainer, CategoryTabs, CategoryTab, TabBarContainer };
